exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-image[data-v-e0800564] {\n  width: 120px;\n  height: 70px;\n}\n.viewbigImg[data-v-e0800564] {\n  position: relative;\n  top: -8px;\n  left: 20px;\n}\n.el-dialog__body[data-v-e0800564] {\n  padding: 10px 10px 0;\n}\n.el-dialog__body .el-alert[data-v-e0800564] {\n    margin-bottom: 10px;\n}\n.el-dialog__body .el-table[data-v-e0800564] {\n    margin-bottom: 10px;\n}\n", ""]);

// exports
